import React from 'react'
import { v4 as uuidv4 } from 'uuid';
import { useStore } from "../../Store";
import { useCreateProductPage } from "../../hooks/useCreateProductPage"
import { CreateProductPageUI } from '../../components/CreateProductPageUI';

export const CreateCoursePage = () => {

    const {course: product, courseCurrentStep: currentStep, courseProgressLoading: progressLoading, updateStates, courseSelectedFilesFromGallery: selectedFilesFromGallery, courseSelectedNewFiles: selectedNewFiles} = useStore((state) => state);

    const {
        dynoCategories,
        loading,
        handleBack,
        handleNext,
        createContent,
        setPrompt,
        onProductDetailSubmit,
        createProductInDB,
        isOpen,
        onOpen,
        onClose,
        generateContent,
        outline,
        setOutline,
        extractTextFromAllFiles,
        prompt,
        loadingMessage,
        isUploadingFromCreateProduct,
        onOutlineChange,
        onModuleTitleChange,
        editMode, 
        setEditMode
    } = useCreateProductPage({uuid: uuidv4(), product, currentStep, progressLoading, updateStates, type: "course"});
    
    return (
        <CreateProductPageUI
            {...{
                dynoCategories,
                loading,
                handleBack,
                handleNext,
                createContent,
                setPrompt,
                onProductDetailSubmit,
                createProductInDB,
                isOpen,
                onOpen,
                onClose,
                generateContent,
                outline,
                setOutline,
                extractTextFromAllFiles,
                prompt,
                product,
                currentStep,
                progressLoading,
                type: "course",
                updateStates, 
                selectedFilesFromGallery, 
                selectedNewFiles,
                loadingMessage,
                isUploadingFromCreateProduct,
                onOutlineChange,
                onModuleTitleChange,
                editMode, 
                setEditMode
            }}
        />
    )
}

